import { render } from "./AddUsersBulk.vue?vue&type=template&id=64d356f9"
import script from "./AddUsersBulk.vue?vue&type=script&lang=js"
export * from "./AddUsersBulk.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__